import React, { useContext, useState } from 'react';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Grid, withStyles } from '@material-ui/core';
import Button from 'components/buttons/Button';
import ContactFormFields from 'components/contact/ContactFormFields';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import { Can, AbilityContext } from 'utils/permissions';


const ContactUpdateForm = ({
  classes,
  handleSubmit,
  onCancel,
  showCustomField,
  ...props
}) => {
  const [areYouSureOpen, setAreYouSureOpen] = useState(false);
  const confirmAreYouSure = () => {
    setAreYouSureOpen(false);
    onCancel();
  };
  const ability = useContext(AbilityContext);
  return (
    <>
      <ConfirmationModal
        open={areYouSureOpen}
        onBackdropClick={() => setAreYouSureOpen(false)}
        title="Confirm"
        confirmLabel="Yes"
        cancelLabel="No"
        onConfirmClick={confirmAreYouSure}
        onCancelClick={() => setAreYouSureOpen(false)}
      >
        All changes will be lost. <br />Are you sure want to cancel?
      </ConfirmationModal>
      <form className={`instance-form ${classes.form}`} autoComplete="off" onSubmit={handleSubmit}>
        <div className="instance-form__body">
          <ContactFormFields
            viewMode={!ability.can('edit', 'Sequence Contact')}
            showCustomField={showCustomField}
            disableEmail
          />
        </div>
        <div className={`instance-form__footer mt-4 ${classes.footer}`}>
          <Can I="edit" a="Sequence Contact">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  type="button"
                  className="w-100"
                  variant="outlined"
                  onClick={props.pristine ? onCancel : () => setAreYouSureOpen(true)}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  className="w-100"
                  disabled={!props.valid || props.submitting || props.pristine}
                >
                  Update Contact
                </Button>
              </Grid>
            </Grid>
          </Can>
        </div>
      </form>
    </>
  );
};


ContactUpdateForm.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  onCancel: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  showCustomField: PropTypes.bool,
};

ContactUpdateForm.defaultProps = {
  className: '',
  showCustomField: true,
};

const styles = theme => ({
  form: {
    width: '100%',
    '& .form-control:disabled': {
      backgroundColor: theme.palette.secondary[50],
    },
  },
  footer: {
    marginTop: '1.5rem',
  },
});

export default compose(
  withStyles(styles),
  reduxForm({ form: 'ContactUpdateForm' }),
)(ContactUpdateForm);
